/**
 * Platform branding configuration.
 *
 * All UI references to the platform name, domain, and support email should
 * use these values instead of hardcoding.
 *
 * Configurable via NEXT_PUBLIC_* env vars so the platform can be white-labeled
 * without code changes.
 */
export const PLATFORM = {
  name: process.env.NEXT_PUBLIC_PLATFORM_NAME || 'turno.core.uy',
  domain: process.env.NEXT_PUBLIC_PLATFORM_DOMAIN || 'core.uy',
  supportEmail: process.env.NEXT_PUBLIC_SUPPORT_EMAIL || 'info@core.uy',
  url: `https://${process.env.NEXT_PUBLIC_PLATFORM_NAME || 'turno.core.uy'}`,
} as const
